"use client";

import Image from "next/image";
import Button from "../ui/Button";
import styles from "./LpHeader.module.css";
import { useState, useEffect } from "react";

const IMG_LOGO = "/images/logo-flex.png";

export default function LpHeader() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    // Lock body scroll when menu is open
    useEffect(() => {
        const html = document.documentElement;
        const body = document.body;

        if (isMenuOpen) {
            html.style.overflow = "hidden";
            body.style.overflow = "hidden";
            html.style.height = "100%";
            body.style.height = "100%";
        } else {
            html.style.overflow = "";
            body.style.overflow = "";
            html.style.height = "";
            body.style.height = "";
        }
        return () => {
            html.style.overflow = "";
            body.style.overflow = "";
            html.style.height = "";
            body.style.height = "";
        };
    }, [isMenuOpen]);

    const handleScroll = (id: string) => {
        setIsMenuOpen(false);
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <header className={styles.header}>
            <div className={styles.container}>
                <div className={styles.logoContainer}>
                    <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className={styles.logoButton} aria-label="Voltar ao topo">
                        <Image src={IMG_LOGO} alt="Flexpro Logo" width={140} height={36} className={styles.logo} priority />
                    </button>
                </div>

                <button
                    className={styles.hamburger}
                    onClick={() => {
                        setIsMenuOpen(!isMenuOpen);
                    }}
                    aria-label="Toggle menu"
                >
                    <div className={`${styles.bar} ${isMenuOpen ? styles.barOpen1 : ''}`}></div>
                    <div className={`${styles.bar} ${isMenuOpen ? styles.barOpen2 : ''}`}></div>
                    <div className={`${styles.bar} ${isMenuOpen ? styles.barOpen3 : ''}`}></div>
                </button>

                <div className={`${styles.navContainer} ${isMenuOpen ? styles.navOpen : ''}`}>
                    <nav className={styles.nav}>
                        <div className={styles.navItem} onClick={() => handleScroll('problema')}>
                            <span className={styles.navText}>Problema</span>
                        </div>
                        <div className={styles.navItem} onClick={() => handleScroll('solucao')}>
                            <span className={styles.navText}>Solução</span>
                        </div>
                        <div className={styles.navItem} onClick={() => handleScroll('beneficios')}>
                            <span className={styles.navText}>Benefícios</span>
                        </div>
                        <div className={styles.navItem} onClick={() => handleScroll('faq')}>
                            <span className={styles.navText}>FAQ</span>
                        </div>
                    </nav>

                    <div className={styles.desktopCta}>
                        <Button onClick={() => handleScroll('contato')}>Solicitar demonstração</Button>
                    </div>

                    <div className={styles.mobileCta}>
                        <Button onClick={() => handleScroll('contato')}>Solicitar demonstração</Button>
                    </div>
                </div>
            </div>
        </header>
    );
}
